// extracted by mini-css-extract-plugin
export default {"main":"home_main__y-s9N","hero":"home_hero__JHecu","typewriter":"home_typewriter__Qjgml"};